import { Observable } from 'rxjs/Observable';
import { concat } from 'rxjs/observable/concat';
import { MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { Http } from '@angular/http';
import { BackendService } from './../../services/backend.service';
import { Page } from 'app/model/page.model';
import { Document } from './../../model/document.model';
import { Component, OnInit, Input } from '@angular/core';
import Helper from 'app/helper';
import { CreatePagesDialogComponent } from 'app/dialogs/ceate-pages-dialog/create-pages-dialog.component';
import { SimpleDialogData } from 'app/dialogs/simple-dialog/simple-dialog';
import { SimpleDialogComponent } from 'app/dialogs/simple-dialog/simple-dialog.component';
import { Connector } from 'app/utils/connector.model';
import { MoveDialogComponent } from 'app/dialogs/move-dialog/move-dialog.component';
import { Translator } from 'angular-translator';

declare var $: any;

@Component({
  selector: 'app-editor-pages',
  templateUrl: './editor-pages.component.html',
  styleUrls: ['./editor-pages.component.scss']
})
export class EditorPagesComponent implements OnInit {
  @Input() document: Document;
  source: any;
  dragEnabled = false;
  filesToUpload: Array<File> = [];
  sourceIndex: number;
  pageToChangeImage: Page;
  mMovablePages: boolean = null;

  multipleSelection: boolean;

  selectedPages: Page[] = [];

  // Upload limits. The backend enforces these as well and is authoritative;
  // checking here only spares the user a long upload that would be rejected anyway.
  static readonly MAX_FILE_SIZE_BYTES = 500 * 1024 * 1024;
  static readonly MAX_REQUEST_SIZE_BYTES = 2 * 1024 * 1024 * 1024;
  static readonly MAX_FILES_PER_REQUEST = 30;

  constructor(private http: Http,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private translator: Translator,
    public backendService: BackendService) {
  }

  ngOnInit() {
    this.multipleSelection = false;
  }


  toggleMultipleSelection() {
    this.selectedPages = [];
    this.multipleSelection = !this.multipleSelection;
  }

  togglePageSelection(page: Page) {
    if (this.selectedPages.indexOf(page) >= 0) {
      this.selectedPages.splice(this.selectedPages.indexOf(page), 1);
    } else {
      this.selectedPages.push(page);
    }
  }

  isPageSelected(page: Page) {
    return this.multipleSelection && this.selectedPages.indexOf(page) >= 0;
  }

  movablePages(): boolean {
    if (this.mMovablePages != null) {
      return this.mMovablePages;
    }
    this.mMovablePages = this.document.isIssue() || this.document.isVolume();
    return this.mMovablePages;
  }

  recalculatePages(page: Page) {
    this.document.recalculatePages(page);
  }

  refreshThumbs() {
    for (const page of this.document.pages) {
      page.refresh += 1;
    }
  }

  removePage(page: Page) {
    this.document.removePage(page);
  }

  moveSelectedPages() {
    if (this.selectedPages.length == 0) {
      return;
    }
    if (this.document.anythingToSave()) {
      this.snackBar.open(
        String(this.translator.instant('common.save_required')),
        String(this.translator.instant('common.ok')),
        { duration: 2000 }
      );
      return;
    }
    const pids = [];
    for (const page of this.document.pages) {
      if (this.selectedPages.indexOf(page) >= 0) {
        pids.push(page.pid);
      }
    }
    const path = this.document.pidPath.split('/');
    const dialogRef = this.dialog.open(MoveDialogComponent, {
      data: { pids: pids, current: this.document.uuid, parent: path[path.length - 2], model: 'issue' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'close') {
        for (const page of this.selectedPages) {
          this.document.removePage(page, false);
        }
        this.selectedPages = [];
      }
    });
  }

  movePage(page: Page) {
    if (this.document.anythingToSave()) {
      this.snackBar.open(
        String(this.translator.instant('common.save_required')),
        String(this.translator.instant('common.ok')),
        { duration: 2000 }
      );
      return;
    }
    const path = this.document.pidPath.split('/');
    const dialogRef = this.dialog.open(MoveDialogComponent, {
      data: { pids: [page.pid], current: this.document.uuid, parent: path[path.length - 2], model: 'issue' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'close') {
        this.document.removePage(page, false);
      }
    });

  }

  addPages() {
    $('#multiple_file_upload').trigger('click');
  }

  addPagesPdf() {
    $('#pdf_file_upload').trigger('click');
  }

  addPagesFromServer() {
    const pid = this.document.pidPath.split('/').pop();
    const baseUrl = Connector.PIXELPRINT_KX_ADMIN_URL;
    //window.open('https://admin.difmoe.eu/processes?action=schedule_import&pid=' + pid, '_blank');
    window.open(baseUrl + '/processes?action=schedule_import&pid=' + pid, '_blank');
  }

  removePages() {
    const data: SimpleDialogData = {
      title: 'common.warning',
      message: 'editor.pages.remove_pages_warn_message',
      btn2: {
        label: 'common.no',
        value: 'no',
        color: 'default'
      },
      btn1: {
        label: 'common.yes',
        value: 'yes',
        color: 'warn'
      }
    };
    const dialogRef = this.dialog.open(SimpleDialogComponent, { data: data });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.document.removeAllPages();
      }
    });
  }

  pdfUploadEnabled(): boolean {
    //return !!Connector.JAVA_BACKEND_URL;
    return !!Connector.JAVA_BACKEND_BASE_URL;
  }


  uploadPdf(fileInput: any) {
    const files = <Array<File>>fileInput.target.files;
    if (files.length != 1) {
      return;
    }
    const dialog: MatDialogRef<CreatePagesDialogComponent> = this.dialog.open(CreatePagesDialogComponent);
    this.backendService.uploadNewPdf(files[0]).subscribe(response => {
      console.log(response);
      const filename = response.filename;
      const pages = response.pages;

      const uuids = [];
      let index = this.document.pages.length;
      const newPages: Page[] = [];
      const empty = index === 0;
      for (let i = 0; i < pages; i++) {
        index += 1;
        const uuid = Helper.newUUID();
        const pageType = index === 1 ? 'TitlePage' : 'NormalPage';
        const pageNumber = empty ? index + '' : '';
        newPages.push(new Page(uuid, pageNumber, pageType));
        uuids.push(uuid);
      }

      const convertRequest = this.backendService.convertUploadedPdf(this.document.uuid, uuids, filename);
      const newPagesRequest = this.backendService.createPages(this.document.uuid, this.document.policy, newPages, true);

      //u stran z pdf (oproti stranám přímo z obrázků) je potřeba nejprve připravit obrázky a ocr a až potom provádět ingest stránek
      //protože foxml se odkazuje přes http url na ocr data a ty datastreamy jsou managed, tedy v okamžiku sklízení do Fedory musí být ocr data dostupná
      //proto zde concat a ne forkJoin
      concat(convertRequest, newPagesRequest).subscribe(
        results => {
          if (results.url.startsWith(Connector.EDITOR_BACKEND_URL)) {
            for (const page of newPages) {
              this.document.pages.push(page);
            }
            dialog.close();
          }
        },
        error => {
          console.log('error', error);
          dialog.componentInstance.onError();
        }
      );

    }, error => {
      console.log('error', error);
      dialog.componentInstance.onError();
    });
  }

  uploadPages(fileInput: any) {
    const files = <Array<File>>fileInput.target.files;
    if (files.length < 1) {
      return;
    }
    const dialog: MatDialogRef<CreatePagesDialogComponent> = this.dialog.open(CreatePagesDialogComponent);

    const limitError = this.checkUploadLimits(files);
    if (limitError) {
      dialog.componentInstance.onError(limitError);
      return;
    }

    const uuids = [];
    let index = this.document.pages.length;
    const newPages: Page[] = [];
    const empty = index === 0;
    for (let i = 0; i < files.length; i++) {
      index += 1;
      const uuid = Helper.newUUID();
      const pageType = index === 1 ? 'TitlePage' : 'NormalPage';
      const pageNumber = empty ? index + '' : '';
      newPages.push(new Page(uuid, pageNumber, pageType));
      uuids.push(uuid);
    }

    const uploadRequest = this.backendService.uploadNewImages(this.document.uuid, uuids, files);
    const newPagesRequest = this.backendService.createPages(this.document.uuid, this.document.policy, newPages, false);
    // forkJoin runs both requests in parallel, so the pages are created even when the
    // upload fails. That is intentional, but it leaves pages without an image behind,
    // hence the second argument telling the dialog to mention it.
    Observable.forkJoin([uploadRequest, newPagesRequest]).subscribe(
      results => {
        for (const page of newPages) {
          this.document.pages.push(page);
        }
        dialog.close();
      },
      error => {
        console.log('error', error);
        dialog.componentInstance.onError(this.extractErrorMessage(error), true);
      }
    );

  }


  /**
   * Returns a message describing the first exceeded upload limit, or null when the
   * selection is fine. Only a convenience, the backend checks the same limits.
   */
  private checkUploadLimits(files: Array<File>): string {
    if (files.length > EditorPagesComponent.MAX_FILES_PER_REQUEST) {
      return this.translator.instant('editor.pages.upload_too_many_files', {
        max: EditorPagesComponent.MAX_FILES_PER_REQUEST,
        count: files.length
      }) as string;
    }
    let totalSize = 0;
    for (let i = 0; i < files.length; i++) {
      totalSize += files[i].size;
      if (files[i].size > EditorPagesComponent.MAX_FILE_SIZE_BYTES) {
        return this.translator.instant('editor.pages.upload_file_too_large', {
          name: files[i].name,
          size: this.formatFileSize(files[i].size),
          max: this.formatFileSize(EditorPagesComponent.MAX_FILE_SIZE_BYTES)
        }) as string;
      }
    }
    if (totalSize > EditorPagesComponent.MAX_REQUEST_SIZE_BYTES) {
      return this.translator.instant('editor.pages.upload_total_too_large', {
        size: this.formatFileSize(totalSize),
        max: this.formatFileSize(EditorPagesComponent.MAX_REQUEST_SIZE_BYTES)
      }) as string;
    }
    return null;
  }

  private formatFileSize(bytes: number): string {
    const mb = bytes / (1024 * 1024);
    return mb >= 1024 ? (mb / 1024).toFixed(1) + ' GB' : Math.round(mb) + ' MB';
  }

  /**
   * Digs the human readable message out of a failed request.
   *
   * The backend answers with an ApiError, so {"message": "..."}, naming the file that
   * was rejected and why. uploadNewImages() does not go through BackendService.handleError,
   * so the error arrives as a raw Response; createPages() does, so it can arrive wrapped
   * in an AppError instead. Some responses are plain text ("Unauthorized"), so fall back
   * to the body and finally to null, which leaves the generic message in place.
   */
  private extractErrorMessage(error: any): string {
    const response = error && error.originalError ? error.originalError : error;
    if (!response) {
      return null;
    }
    try {
      const body = typeof response.json === 'function' ? response.json() : null;
      if (body && body.message) {
        return body.message;
      }
    } catch (e) {
      // not a JSON body, the raw text below is the best we can do
    }
    try {
      const text = typeof response.text === 'function' ? (response.text() || '').trim() : '';
      // A container error page is HTML and would fill the dialog with markup,
      // so only pass through something that looks like a short plain message.
      if (text && text.length <= 300 && text.charAt(0) !== '<') {
        return text;
      }
    } catch (e) {
      // no readable body, the generic message stays
    }
    return null;
  }


  // changePageImage(page: Page) {
  //   this.pageToChangeImage = page;
  //   $('#single_file_upload').trigger('click');
  // }

  // onChangePageImage(fileInput: any) {
  //   const files = <Array<File>>fileInput.target.files;
  //   this.backendService.changePageImage(this.document.uuid, this.pageToChangeImage.pid, files).subscribe(
  //     result => {
  //       this.pageToChangeImage.refresh += 1;
  //     },
  //     error => console.log('File Change Error', error)
  //   );
  // }


  // Drag & Drop //

  isbefore(a, b) {
    if (a.parentNode === b.parentNode) {
      for (let cur = a; cur; cur = cur.previousSibling) {
        if (cur === b) {
          return true;
        }
      }
    }
    return false;
  }

  dragenter($event) {
    if (this.source.parentNode !== $event.currentTarget.parentNode) {
      return;
    }
    const target = $event.currentTarget;
    if (this.isbefore(this.source, target)) {
      target.parentNode.insertBefore(this.source, target); // insert before
    } else {
      target.parentNode.insertBefore(this.source, target.nextSibling); // insert after
    }
  }

  dragend($event) {
    const targetIndex = this.getIndex(this.source);
    const from = this.sourceIndex - 1;
    const to = targetIndex - 1;
    if (from !== to) {
      this.document.reorderPages(from, to);
    }
  }

  dragstart($event) {
    if (!this.dragEnabled) {
      return;
    }
    this.source = $event.currentTarget;
    this.sourceIndex = this.getIndex(this.source);
    $event.dataTransfer.effectAllowed = 'move';
  }

  mousedown($event) {
    if ($event.target.classList.contains('page-drag-handle') > 0) {
      this.dragEnabled = true;
    } else {
      $event.preventDefault();
      this.dragEnabled = false;
    }
  }

  private getIndex(el) {
    return Array.prototype.indexOf.call(el.parentNode.childNodes, el);
  }



}
